import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { GetCompanySettingsResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ArableCustomerService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service/organisation/`;

  getCompanySettings(year: number): Observable<GetCompanySettingsResponse> {
    return this.http.get<GetCompanySettingsResponse>(`${this.baseUrl}/companysettings/year/${year}`);
  }
}
